import { render, staticRenderFns } from "./PurchaseCoupon.vue?vue&type=template&id=0871248c&scoped=true&"
import script from "./PurchaseCoupon.vue?vue&type=script&lang=js&"
export * from "./PurchaseCoupon.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseCoupon.vue?vue&type=style&index=0&id=0871248c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0871248c",
  null
  
)

export default component.exports